module.exports = __webpack_public_path__ + "b351bd62abcd96e924d9f44a3da169a7.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/onsenui/css/material-design-iconic-font/fonts/Material-Design-Iconic-Font.ttf
// module id = 307
// module chunks = 1